import { createStorageAtomFactory } from '@exodus/atoms'

const createFiatHiddenFailedOrderNotificationsAtom = ({ storage }) =>
  createStorageAtomFactory({ storage })({
    key: 'fiatHiddenFailedOrderNotifications',
    defaultValue: {},
    isSoleWriter: true,
  })

const fiatHiddenFailedOrderNotificationsDefinition = {
  id: 'fiatHiddenFailedOrderNotificationsAtom',
  type: 'atom',
  factory: createFiatHiddenFailedOrderNotificationsAtom,
  dependencies: ['storage'],
  public: true,
}

export default fiatHiddenFailedOrderNotificationsDefinition
